import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import CheckRoundedIcon from '@material-ui/icons/CheckRounded'
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded'
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded'
import classnames from 'classnames'
import * as React from 'react'

import { InstructionsNavList } from './InstructionsNavList'
import './style.scss'

interface IProps {
  activeStep: number
  activeStepHasNav: boolean
  isActiveStepLast: boolean
  onClickNavItem: (id: number) => void
  onClickNext: () => void
  onClickDone: () => void
  btnLoading: boolean
}

export const InstructionsNav: React.FC<IProps> = ({
  activeStep,
  activeStepHasNav,
  isActiveStepLast,
  onClickNavItem,
  onClickNext,
  onClickDone,
  btnLoading
}) => {
  const returnNextIcon = (iconClassName: string): React.ReactNode => (
    <CheckRoundedIcon classes={{ root: iconClassName }} />
  )

  const returnNextBtn = (hasBgCol = false): React.ReactNode => (
    <div className="nav-btn-next-wrap">
      <IconButton
        classes={{
          root: classnames('nav-btn-next', 'max-laptop', {
            'nav-btn-next-col-bg': hasBgCol
          })
        }}
        onClick={isActiveStepLast ? onClickDone : onClickNext}
        disabled={btnLoading}
      >
        {isActiveStepLast ? (
          returnNextIcon('next-icon')
        ) : (
          <KeyboardArrowDownRoundedIcon classes={{ root: 'next-icon' }} />
        )}
      </IconButton>
      <Button
        classes={{
          root: classnames('nav-btn-next', 'min-desktop', {
            'nav-btn-next-col-bg': hasBgCol
          })
        }}
        onClick={isActiveStepLast ? onClickDone : onClickNext}
        disabled={btnLoading}
      >
        {isActiveStepLast ? 'done' : 'next'}
        {isActiveStepLast ? (
          returnNextIcon('next-icon-desktop')
        ) : (
          <KeyboardArrowRightRoundedIcon
            classes={{ root: 'next-icon-desktop' }}
          />
        )}
      </Button>
      {btnLoading && <CircularProgress size={24} className="btn-progress" />}
    </div>
  )
  const returnInstructionsNav = () => {
    if (activeStep === 0) {
      return (
        <Button classes={{ root: 'nav-btn-start' }} onClick={onClickNext}>
          Start
        </Button>
      )
    }
    if (activeStepHasNav) {
      return (
        <>
          <InstructionsNavList
            activeStep={activeStep}
            onClickNavItem={onClickNavItem}
          />
          {returnNextBtn()}
        </>
      )
    }

    return returnNextBtn(true)
  }

  return <div className="instructions-nav-wrap">{returnInstructionsNav()}</div>
}



// WEBPACK FOOTER //
// ./src/components/ParentalInstructions/InstructionsNav.tsx